export default {
  computed: {
    columnsToDisplay() {
      const columns = [];

      const storedColumnNames = localStorage.getItem(this.localStorageKey);
      if (storedColumnNames) {
        storedColumnNames.split(',').forEach((columnName) => {
          const column = Object.values(this.availableColumns)
            .find(d => [d.name, d.headerName].includes(columnName));

          if (column) columns.push(column);
        });
      }

      return columns.length ? columns : this.defaultColumns;
    },
  },

  methods: {
    /**
     * Store column selection in local storage.
     * This will eventually be stored in a database following future work.
     */
    handleColumnsChange(columnNames) {
      localStorage.setItem(this.localStorageKey, columnNames);
    },

    /**
     * Reset the local storage columns to the default.
     * This should be done differently following future work.
     */
    handleRevertColumns() {
      const columnNames = this.defaultColumns.reduce((accumulator, column) => {
        accumulator.push(column.name);
        return accumulator;
      }, []);

      // Reset stored columns
      localStorage.setItem(this.localStorageKey, columnNames);
    },
  },
};
